// import redux and persist plugins
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'reduxjs-toolkit-persist';
import storage from 'reduxjs-toolkit-persist/lib/storage';
import persistStore from 'reduxjs-toolkit-persist/es/persistStore';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'reduxjs-toolkit-persist/es/constants';

// import theme reducers
// import persist key
import { REDUX_PERSIST_KEY } from 'config.js';
import settingsReducer from 'slices/settings/settingsSlice';
import layoutReducer from 'layout/layoutSlice';
import langReducer from 'lang/langSlice';
import authReducer from 'slices/auth/authSlice';
import menuReducer from 'layout/nav/main-menu/menuSlice';
import notificationReducer from 'layout/nav/notifications/notificationSlice';
import scrollspyReducer from 'components/scrollspy/scrollspySlice';
import additionalChargesReducer from 'slices/uiStates/additionalChargesSlice';
import additionalChargesPendingReducer from 'slices/uiStates/additionalChargesPendingSlice';
import senderDataReducer from './slices/shipping/senderDataSlice';
import receiverDataReducer from './slices/shipping/receiverDataSlice';
import parcelDataReducer from './slices/shipping/parcelDataSlice';
import insuranceDataReducer from './slices/shipping/insuranceDataSlice';
import ratesDataReducer from './slices/shipping/ratesDataSlice';
import shippingDataReducer from './slices/shipping/shippingDataSlice';
import generalDataReducer from './slices/generalData/generalData';
import addressDataReducer from './slices/addresses/addressDataSlice';
import parcelSelectedReducer from './slices/parcels/parcelSelectedSlice';
import allUsersReducer from './slices/uiStates/allUsersSlice';
import allShippingsReducer from './slices/uiStates/allShippingsSlice';
import allOverweightReducer from './slices/uiStates/allOverweightSlice';
import allOrderOverweightReducer from './slices/uiStates/allOrderOverweightSlice';
import allPendingOverweightReducer from './slices/uiStates/allPendingOverweightSlice';
import allCancellationsReducer from './slices/uiStates/allCancellationsSlice';
import pickupsReducer from './slices/uiStates/pickupsSlice';
import reportsReducer from './slices/uiStates/reportsSlice';
import suggestionsReducer from './slices/uiStates/suggestionsSlice';
import userOrdersReducer from './slices/uiStates/userOrdersSlice';
import userShippingsReducer from './slices/uiStates/userShippingsSlice';
import userPluginOrdersReducer from './slices/uiStates/userPluginOrdersSlice';
import storeAssignmentsReducer from './slices/uiStates/storeAssignmentsSlice';
import batchCancellationsReducer from './slices/uiStates/batchCancellationsSlice';
import metricsReducer from './slices/uiStates/metricsSlice';
import destinationNotificationReducer from './slices/shipping/destinationNotificationDataSlice';

// *GLOBAL STATE SETTING*
const persistConfig = {
  key: REDUX_PERSIST_KEY,
  storage,
  whitelist: ['auth', 'menu', 'settings', 'lang'],
};
// -The Reducers are controling pieces of states which we call slice and are imported and are configured in persistedReducer
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    layout: layoutReducer,
    lang: langReducer,
    auth: authReducer,
    menu: menuReducer,
    notification: notificationReducer,
    scrollspy: scrollspyReducer,
    shipping_sender: senderDataReducer,
    shipping_receiver: receiverDataReducer,
    shipping_parcel: parcelDataReducer,
    shipping_insurance: insuranceDataReducer,
    shipping_rates: ratesDataReducer,
    shipping: shippingDataReducer,
    shipping_destination_notification: destinationNotificationReducer,
    general_data: generalDataReducer,
    address_data: addressDataReducer,
    parcel_data: parcelSelectedReducer,
    all_users: allUsersReducer,
    all_shippings: allShippingsReducer,
    all_overweight: allOverweightReducer,
    all_order_overweight: allOrderOverweightReducer,
    all_pending_overweight: allPendingOverweightReducer,
    all_cancellations: allCancellationsReducer,
    pickups: pickupsReducer,
    reports: reportsReducer,
    suggestions: suggestionsReducer,
    user_orders: userOrdersReducer,
    user_shippings: userShippingsReducer,
    user_plugin_orders: userPluginOrdersReducer,
    store_assignments: storeAssignmentsReducer,
    all_charges: additionalChargesReducer,
    all_charges_pending: additionalChargesPendingReducer,
    batch_cancellations: batchCancellationsReducer,
    metrics: metricsReducer,
  })
);
// -The Store sets up global states whit all reducers, these are imported from their respective folders
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };
